import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useWishlist } from '../context/WishlistContext';
import { products } from '../data/products';
import ProductCard from '../components/ProductCard';
import { Heart, Trash2 } from 'lucide-react';

const Wishlist = () => {
  const { ids, clear } = useWishlist();
  useEffect(() => { window.scrollTo(0, 0); }, []);

  const saved = ids.map(id => products.find(p => p.id === id)).filter(Boolean);

  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-12">
      <div className="text-center mb-12">
        <div className="uppercase tracking-[0.35em] text-xs text-[#7a8b6b] mb-3">Saved for you</div>
        <h1 className="font-serif-elegant text-5xl md:text-6xl">Your Wishlist</h1>
        <p className="mt-4 text-[#4a4640] max-w-xl mx-auto">The herbs, elixirs and rituals you&rsquo;re dreaming about.</p>
      </div>

      {saved.length === 0 ? (
        <div className="py-24 text-center">
          <Heart className="w-14 h-14 mx-auto text-[#7a8b6b] mb-6" />
          <p className="font-serif-elegant text-2xl mb-2">Nothing saved yet</p>
          <p className="text-[#6f6a5f] mb-8">Tap the heart on any product to add it here.</p>
          <Link to="/collections/all" className="btn-primary">Browse Products</Link>
        </div>
      ) : (
        <>
          <div className="flex justify-end mb-6">
            <button onClick={clear} className="inline-flex items-center gap-2 text-xs uppercase tracking-widest text-[#6f6a5f] hover:text-[#7a3b2e]">
              <Trash2 className="w-4 h-4" /> Clear wishlist
            </button>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-6 gap-y-12">
            {saved.map(p => <ProductCard key={p.id} product={p} />)}
          </div>
        </>
      )}
    </div>
  );
};

export default Wishlist;
